<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Accounts', :nav='nav')
    router-link(:to='{ name: "CreateAccount" }')
      md-button.md-fab.md-fab-bottom-right.md-icon-button
        md-icon(md-iconset="fa fa-plus")
    account-table.content-table
</template>

<script>
  import AccountTable from '../../shared-components/account/AccountTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      AccountTable,
      Breadcrumbs
    },
    data() {
      return {
        nav: [
          { 'title': "Accounts" }
        ]
      };
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/account/AccountList.vue